import logoImg from '../assets/img/logo.webp';

type LogoProps = {
  width: number,
}

export function Logo({ width }: LogoProps) {

  return (
    <div className='flex flex-col justify-center items-center'>
      <img src={logoImg} className='aspect-[1.0255]' width={width} alt="Logo" />
    </div>
  )
}
